export default __webpack_public_path__ + "static/media/kitchen3-before2.1a5e97fb.jpg";